import { friendlyApiErrorMessage } from 'src/app/services/api-error-notifier.service';
import { HttpClient } from "@angular/common/http";
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/services/api.service";
import { FilterService } from "src/app/services/filter.service";

@Component({
    selector: "app-small-bar-widget-chart",
    templateUrl: "./small-bar-chart.component.html",
    styleUrls: ["./small-bar-chart.component.scss"],
    standalone: false
})
export class SmallBarChartComponent implements OnInit, OnDestroy  {
  static key = 100606;

  @Input("item") item: any;
  @Input("pageKey") pageKey: any;
  @Input("dynamic") dynamic!: any;
  @Output("onSizeChange") onSizeChange = new EventEmitter<any>();
  @ViewChild("smallBarChart", { static: true }) smallBarChart!: ElementRef;

  config: any;
  data: any;
  heading: any;
  isDataLoaded = false;
  error_name:any;
  reqSubcription: Subscription[] = [];
  constructor(private filterService: FilterService, private httpClient: HttpClient, private apiService: ApiService) {
    this.reqSubcription.push(
      this.filterService.filterQuery.subscribe((query: any) => {
        this.loadApiData();
      })
    );

    // Nested Widgets
    this.reqSubcription.push(
      this.filterService.triggerNestedQuery.subscribe((query: any) => {
        if(query == this.item.widget_uniq_key) {
          this.loadApiData();
        }
      })
    );
  }
  ngOnInit(): void {
    // debugger
    this.loadlineConfig();
    const observerone = new ResizeObserver((e: any) => {
      this.onSizeChange.emit(e[0].contentRect.height);
    });
    observerone.observe(this.smallBarChart.nativeElement);
    // if(this.dynamic==true){
    //   this.loadApiData()
    // }
   }

  loadlineConfig() {
    this.heading = this.item.config["report_heading"];
  }

  loadApiData(reportType?: string) {
    let api = this.item.config["list_of_api"] || {};
    let widgetEndpoint = this.item?.config?.['widget_endpoint']||null;

    if(this.filterService.isEmptyObject(this.filterService.baseQuery) == false) {

      // API Payload
      let obj:any = {"api_key" : api?.api_key ? api?.api_key : api}

      let query = Object.assign({}, this.filterService.baseQuery, obj)
      query["report_typ"] = this.filterService.report_type;
      query['module_key'] = this.apiService.getModuleKey();
      let endPoint = this.item.config?.["list_of_api_endpoint"] || '';
      this.reqSubcription.push(
        this.httpClient.post(`${this.apiService.apiBaseUrl}/${widgetEndpoint??this.apiService.executionUrl}`, query).subscribe((res:any)=> {
          
          this.isDataLoaded = true
          this.data = res == null ? [] : res
          this.error_name = '';
        },(err:any)=>{
          console.log(err)
          this.data = []
          this.isDataLoaded = true;
          this.error_name = friendlyApiErrorMessage(err);
        })
      )

      // this.reqSubcription.push(
      //   this.filterService.executeQuery(obj).subscribe(
      //     (res: any) => {
      //       this.isDataLoaded = true;
      //       this.data = res == null ? [] : res;
      //     },
      //     (error: any) => {
      //       this.data = [];
      //     }
      //   )
      // );
    }
  }
  ngOnDestroy(): void {
    this.reqSubcription.forEach(res => res.unsubscribe())
  }
}
